import React from 'react';
import { Icon } from './ui/Icon';
import { BlockIcon } from './ui/primitives';

interface Props {
  onDiscordLogin: () => void;
  onDevLogin?: () => void;
  error?: string | null;
}

export const DISCORD_INVITE = 'https://discord.gg/bakerybuilders';

const Login: React.FC<Props> = ({ onDiscordLogin, onDevLogin, error }) => (
  <div className="login2">
    <div className="login2-l">
      <img className="mark mark--img" src="/bakerylogo.png" alt="" width={52} height={52} />
      <h1>
        Welcome to
        <br />
        the Bakery Worlds.
      </h1>
      <p className="sub">Manage your private Minecraft worlds - settings, backups, activity, and a map of everything you've built.</p>
      {error && (
        <p className="sub" style={{ color: 'var(--danger)', marginTop: -20 }}>
          {error}
        </p>
      )}
      <button type="button" className="lbtn lbtn--d" onClick={onDiscordLogin}>
        <Icon name="discord" size={18} /> Continue with Discord
      </button>
      <a className="lbtn" href={DISCORD_INVITE} target="_blank" rel="noopener noreferrer">
        <Icon name="discord" size={17} /> Not a member yet? Join the Discord
      </a>
      {onDevLogin && (
        <button type="button" className="lbtn lbtn--dev" onClick={onDevLogin}>
          <Icon name="settings" size={16} /> Dev login (local only)
        </button>
      )}
      <p className="foot">Private worlds are managed for members of the Bakery Discord. By continuing you agree to the community guidelines.</p>
    </div>
    <div className="login2-r" aria-hidden>
      <span className="float-blk" style={{ top: '22%', left: '24%', ['--rot' as string]: '-8deg', animationDelay: '0s' }}>
        <BlockIcon block="grass" size={52} />
      </span>
      <span className="float-blk" style={{ top: '44%', right: '22%', ['--rot' as string]: '10deg', animationDelay: '1.2s' }}>
        <BlockIcon block="diamond" size={40} />
      </span>
      <span className="float-blk" style={{ top: '14%', right: '36%', ['--rot' as string]: '4deg', animationDelay: '2.1s' }}>
        <BlockIcon block="gold" size={30} />
      </span>
      <span className="float-blk" style={{ bottom: '20%', left: '38%', ['--rot' as string]: '-5deg', animationDelay: '3s' }}>
        <BlockIcon block="oak" size={36} />
      </span>
      <span className="float-blk" style={{ bottom: '32%', right: '40%', ['--rot' as string]: '7deg', animationDelay: '1.7s' }}>
        <BlockIcon block="netherrack" size={26} />
      </span>
    </div>
  </div>
);

export default Login;
